import { ApplianceDetailsModelSerialFormConfig } from '../../models/appliance-details-model-serial/appliance-details-model-serial-form-config.interface';
import { mockCmsApplianceDetailsModelSerialForm } from './cms-appliance-details-model-serial-form.mock';

export const mockApplianceDetailsModelSerialFormConfig: ApplianceDetailsModelSerialFormConfig =
  {
    cmsData: mockCmsApplianceDetailsModelSerialForm,
    modelNumberRequired: true,
    serialNumberRequired: true,
  };
